import React from "react";
import { Logo } from "@common/logo";
import styles from "./styles.scss";

function Loader() {
  return (
    <div className={styles.loader}>
      <div className={styles.logo}>
        <Logo className={styles.icon} />
      </div>
    </div>
  );
}

export { Loader };
